module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/2_dbb1aaceb816eaca0ffd857fa9d79a44.png";